<template>
  <div>
    <data-table :service="LogService"
                :entity="entity"
                :go-to-details-on-row-click="false"
                :columns="columns"
                operations="refresh"
                ref="table">
      <template slot="name" slot-scope="{row}">
        {{row.name}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import entities from 'src/config/entities';
  import LogService from 'src/services/LogService';
  export default {
    name: 'job-logs',
    data() {
      return {
        LogService,
        entity: entities.LOG
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "name",
            label: this.$t('job.details.logs.name'),
            minWidth: "150px",
            sortable: true
          }
        ]
      }
    }
  }
</script>
<style>
</style>
